import { FormControl } from 'baseui/form-control'
import useAddress from '@/containers/SubscriptionFormPageNew/Components/Address/useAddress'
import SDButtonGroup from '@/shared/components/SDComponentsNewDesign/SDButtonGroup/SDButtonGroup'
import getError from '@/containers/SubscriptionFormPage/getError'

const RecentInsulationWorkField = () => {
  const { t, energyLandscape, updateAddressEnergyLandscape, errors } = useAddress()

  return (
    <FormControl
      label={t('subscriptionTools:estimator.recent_insulation_work.label')}
      error={getError('recentInsulationWork', errors)}
    >
      <SDButtonGroup
        onClickHandler={value => {
          updateAddressEnergyLandscape({ recentInsulationWork: value })
        }}
        options={[{ YES: 'Oui' }, { NO: 'Non' }]}
        selectedValue={energyLandscape?.recentInsulationWork}
      />
    </FormControl>
  )
}

export default RecentInsulationWorkField
